<template>
  <div class="slider-component question-type-component">
    <div class="hint-text" v-if="$props.question.hint" v-html="$props.question.hint.get()"></div>
    <div>
      <SliderComponent @change="emit('change')"
                       :min="1"
                       :max="10"
                       :step="1"
                       label
                       markers
                       inner-track-color="transparent"
                       v-model="submission['root'][$props.question.path]"
      ></SliderComponent>
      <div class="legend">
        <div class="low" @click="onLow"><label>{{ props.question.sliderLabels.minimumLabel.get() }}</label></div>
        <div class="high" @click="onHigh"><label>{{ props.question.sliderLabels.maximumLabel.get() }}</label></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import QualityMentoringFormQuestion from '../../models/QualityMentoringFormQuestion';
import { inject, nextTick, ref } from 'vue';
import { getLocale } from '../../../../core/Utils';

const props = defineProps({
  question: QualityMentoringFormQuestion,
  submission: Object
})

if(!props.submission['root']) {
  props.submission['root'] = {};
}

const emit = defineEmits(['change']);

const onLow = () => {
  props.submission['root'][props.question.path] = 1;
  emit('change');
}

const onHigh = () => {
  props.submission['root'][props.question.path] = 10;
  emit('change');
}

const page = inject('page');

function clear() {
  if(props.submission['root']) {
    delete props.submission['root'][props.question.path];
  }
}

defineExpose({
  clear
})
</script>

<style lang="scss">
.slider-component {
  .legend {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: -8px;
      height: 16px;
      width: 1px;
      background-color: rgba(var(--mc-2022-silver-color-rgb), 1);
      pointer-events: none;
    }
    &:before {
      left: 0;
    }
    &:after {
      right: 0;
    }
  }
}
</style>
